import templateUrl from './dialog-close.html';

export default {
  templateUrl,
  controller: class DialogCloseComponent {
    constructor($mdDialog) {
      'ngInject';

      Object.assign(this, { $mdDialog });
    }

    close() {
      this.$mdDialog.hide();
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/dialog-close/dialog-close.component.js